import { PlusOutlined } from "@ant-design/icons";
import { Button, Tabs } from "antd";
import { FC, useState } from "react";
import { Bell } from "lucide-react";
import { ModalStaff } from "../modal-staff";
import { ModalImportStaff } from "../modal-staff/modal-import-staff";
import { useStaffStore } from "../staffs.store";
import { AvailabilityCalendar } from "./availability-calendar";
import { PerformancePayroll } from "./performance-payroll";
import { SkillTracking } from "./skill-tracking";
import { StaffDirectory } from "./staff-directory";
import { AvailabilityReminderModal } from "./availability-reminder-modal";

type Props = {};

export const ListStaffs: FC<Props> = () => {
  const { openStaffModal } = useStaffStore();
  const [reminderModalOpen, setReminderModalOpen] = useState(false);

  const tabItems = [
    {
      key: "directory",
      label: "Staff Directory",
      children: (
        <>
          <StaffDirectory />
        </>
      ),
    },
    {
      key: "availability",
      label: "Availability Calendar",
      children: (
        <div style={{ padding: "24px", background: "#fff", borderRadius: "8px" }}>
          <AvailabilityCalendar />
        </div>
      ),
    },
    {
      key: "tracking",
      label: "Skills & Performance",
      children: (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "24px", marginTop: "24px" }}>
          <SkillTracking />
          <PerformancePayroll />
        </div>
      ),
    },
  ];

  return (
    <div>
      <ModalStaff />
      <AvailabilityReminderModal
        open={reminderModalOpen}
        onClose={() => setReminderModalOpen(false)}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <h2 style={{ fontSize: "24px", fontWeight: 600 }}>Staff Management</h2>
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            icon={<Bell size={16} />}
            onClick={() => setReminderModalOpen(true)}
          >
            Send Availability Reminder
          </Button>
          <ModalImportStaff />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => openStaffModal()}
          >
            Add Staff Member
          </Button>
        </div>
      </div>

      <Tabs defaultActiveKey="directory" items={tabItems} size="large" />
    </div>
  );
};
